const setProp = (props, value, obj, stato) => {
  const name = props;
  if (name.indexOf('.') != -1) {
    const properties = name.split('.');
    setPropRecursive(properties, value, obj, stato);
  } else {
    obj[name] = value;
  }
};

const setPropRecursive = (properties, value, obj, stato) => {
  const [prop] = properties;
  properties.splice(0, 1);
  if (prop.indexOf('[') != -1) {
    const propName = prop.substring(0, prop.indexOf('['));
    let propIndex = prop.substring(prop.indexOf('[') + 1, prop.indexOf(']'));
    propIndex = parseInt(propIndex, 10);
    if (properties.length > 0) {
      obj[propName] = JSON.parse(JSON.stringify(stato[propName] || {}));
      if (obj[propName][propIndex] == null) {
        obj[propName][propIndex] = {};
      }

      setPropRecursive(properties, value, obj[propName][propIndex], stato[propName][propIndex] || {});
    } else {
      obj[propName][propIndex] = value;
    }
  } else if (properties.length > 0) {
    if (stato[prop] !== null && typeof stato[prop] === 'object') {
      obj[prop] = JSON.parse(JSON.stringify(stato[prop] || {}));
    } else {
      obj[prop] = stato[prop] || {};
    }

    setPropRecursive(properties, value, obj[prop], stato[prop] || {});
  } else {
    obj[prop] = value;
  }
};

/**
 * Return the value of a stato property by props path, or '' if the path doesn't exist.
 * props uses the dot notation to identity an object property or
 * [index] to identify an array item.
 * ex: Dichiarativo.Messaggi[2]
 * @param {string} props return property path
 * @param {object | array} stato source object where extract the value.
 */
const getProp = (props, stato) => {
  if (props === undefined) {
    return '';
  }
  const name = props;
  if (name.indexOf('.') != -1) {
    const properties = name.split('.');
    let temp = stato;
    for (let i = 0; i < properties.length; i += 1) {
      const prop = properties[i];
      if (prop.indexOf('[') != -1) {
        const propName = prop.substring(0, prop.indexOf('['));
        let propIndex = prop.substring(prop.indexOf('[') + 1, prop.indexOf(']'));
        propIndex = parseInt(propIndex, 10);
        if (temp[propName] == undefined) {
          return '';
        }
        temp = temp[propName][propIndex];
        if (temp == undefined) {
          return '';
        }
      } else {
        temp = temp[prop];
        if (temp == undefined) {
          return '';
        }
      }
    }
    return temp == null ? '' : temp;
  }
  return stato[name] == null ? '' : stato[name];
};

export {
  setProp,
  getProp,
};
